import React from "react";
import { Box } from "@mui/material";
import theme from "../../../../../Layouts/theme";

const CardDropIndicator = ({ visible, position = "top" }) => {
  if (!visible) return null;

  const isTop = position === "top";

  return (
    <Box
      sx={{
        position: "absolute",
        left: 0,
        right: 0,
        height: "2px",
        backgroundColor: theme.palette.primary.main,
        borderRadius: "2px",
        boxShadow: `0 0 8px ${theme.palette.primary.main}`,
        zIndex: 20,
        ...(isTop ? { top: "-6px" } : { bottom: "-6px" }),
      }}
    />
  );
};

export default CardDropIndicator;
